import { ORDER_STATUS } from './orderStatus'

export const ORDER_STEPS = [
	[ORDER_STATUS.created],
	[ORDER_STATUS.in_preparation, ORDER_STATUS.ready],
	[
		ORDER_STATUS.shipped,
		ORDER_STATUS.on_delivery,
		ORDER_STATUS.on_international_transit,
	],
	[ORDER_STATUS.in_store, ORDER_STATUS.in_droppoint],
	[ORDER_STATUS.delivered],
]
